"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

var _fi = require("react-icons/fi");

var _go = require("react-icons/go");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n/* clears the 'X' from Internet Explorer */\ninput[type='search']::-ms-clear {\n  display: none;\n  width: 0;\n  height: 0; }\n\ninput[type='search']::-ms-reveal {\n  display: none;\n  width: 0;\n  height: 0; }\n\n/* clears the 'X' from Chrome */\ninput[type='search']::-webkit-search-decoration,\ninput[type='search']::-webkit-search-cancel-button,\ninput[type='search']::-webkit-search-results-button,\ninput[type='search']::-webkit-search-results-decoration {\n  display: none; }\n\n.container {\n  font-family: \"OpenSansRegular\"; }\n\n.search-container {\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  padding: 0.5rem;\n  border-radius: 0.1875rem;\n  border: 0.0625rem solid #6f6f6f;\n  height: 2.5rem; }\n\n.search-container:focus-within {\n  border: 0.125rem solid #067fdb;\n  padding: 0.4375rem; }\n\n.search-container-disabled {\n  border: 0.0625rem solid #c6c6c6; }\n\n.search-container > input {\n  padding: 0; }\n\n.search-container > .search-box {\n  transform: translateY(2px); }\n\n.search-box {\n  font-family: \"OpenSansRegular\";\n  width: 100%;\n  font-size: 0.875rem;\n  background: transparent;\n  vertical-align: middle;\n  line-height: 1.1875rem;\n  height: 1.1875rem;\n  color: #393939;\n  outline: none;\n  border: none;\n  overflow: hidden;\n  -o-text-overflow: ellipsis;\n  -ms-text-overflow: ellipsis;\n  text-overflow: ellipsis; }\n\n.search-box::placeholder {\n  color: #8d8d8d;\n  opacity: 1; }\n\n.search-box-disabled {\n  color: #c6c6c6; }\n\n.search-icon-box {\n  vertical-align: middle;\n  width: 1.5rem;\n  height: 1.5rem;\n  align-items: center; }\n\n.search-icon {\n  color: #8d8d8d;\n  margin-right: 0.5rem; }\n\n.search-icon-disabled {\n  color: #c6c6c6; }\n\n.clear-icon {\n  color: #6f6f6f;\n  margin-left: 0.5rem; }\n\n.clear-icon-disabled {\n  color: #c6c6c6; }\n";
  var fileName = "compone_search";
  var element = document.querySelector("style[data-sass-component='compone_search']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var SearchInput = function SearchInput(_ref) {
  var _searchMainClass, _searchBoxClass, _searchIconClass, _clearIconClass;

  var value = _ref.value,
      onChange = _ref.onChange,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      width = _ref.width,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? _constants.inputPlaceholder : _ref$placeholder;
  var searchMainClass = (_searchMainClass = {}, _defineProperty(_searchMainClass, _constants.classes.searchContainer, true), _defineProperty(_searchMainClass, _constants.classes.searchContainerDisabled, disabled), _searchMainClass);
  var searchBoxClass = (_searchBoxClass = {}, _defineProperty(_searchBoxClass, _constants.classes.searchBox, true), _defineProperty(_searchBoxClass, _constants.classes.searchBoxDisabled, disabled), _searchBoxClass);
  var searchIconClass = (_searchIconClass = {}, _defineProperty(_searchIconClass, _constants.classes.searchIconBox, true), _defineProperty(_searchIconClass, _constants.classes.searchIcon, true), _defineProperty(_searchIconClass, _constants.classes.searchIconDisabled, disabled), _searchIconClass);
  var clearIconClass = (_clearIconClass = {}, _defineProperty(_clearIconClass, _constants.classes.searchIconBox, true), _defineProperty(_clearIconClass, _constants.classes.clearIcon, true), _defineProperty(_clearIconClass, _constants.classes.clearIconDisabled, disabled), _clearIconClass);
  var searchRef = (0, _react.useRef)();

  var getSearchIcon = function getSearchIcon() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_objectSpread({}, searchIconClass))
    }, /*#__PURE__*/_react.default.createElement(_go.GoSearch, {
      size: _constants.searchIconSize
    }));
  };

  var getInputField = function getInputField() {
    return /*#__PURE__*/_react.default.createElement("input", {
      ref: searchRef,
      className: (0, _classnames.default)(_objectSpread({}, searchBoxClass)),
      type: _constants.inputType,
      value: value,
      placeholder: placeholder,
      onChange: onChange,
      disabled: disabled,
      role: _constants.searchInputRole
    });
  };

  var handleOnClear = function handleOnClear() {
    searchRef.current.value = null;
    var e = new Event('change', {
      bubbles: true
    });
    searchRef.current.dispatchEvent(e);
  };

  var getClearIcon = function getClearIcon() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_objectSpread({}, clearIconClass)),
      style: {
        cursor: disabled ? 'default' : 'pointer'
      },
      onClick: !disabled ? handleOnClear : null
    }, /*#__PURE__*/_react.default.createElement(_fi.FiX, {
      size: _constants.clearIconSize
    }));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: _constants.searchRole,
    className: (0, _classnames.default)(_objectSpread({}, searchMainClass)),
    style: {
      width: "".concat(width)
    }
  }, getSearchIcon(), getInputField(), value !== '' && getClearIcon()));
};

SearchInput.propTypes = {
  value: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  width: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  placeholder: _propTypes.default.string
};
var _default = SearchInput;
exports.default = _default;